import React from 'react'
import ModalComponent from './ModalComponent'

export default function LogoutModal(props) {
    return (
        <div>
            {props.showLogoutModal ?
                <ModalComponent>
                    <div class="modal-dialog">
                        <div class="modal-content py-4">
                            <div class="modal-body text-center">

                                <h6> Are you sure you want to logout ?</h6>
                                <div className='d-flex justify-content-center pt-3'>
                                    <button type="button" class="btn btn-primary" onClick={() => props.onLogoutFunction()}>Log out</button>
                                    <button type="button" class="btn btn-danger" onClick={() => props.onCancelFunction()}>Cancel</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </ModalComponent> : ""}
        </div>
    )
}
